import { get, post, del } from 'modules/api';

export const postProfessionPractices = (farmId, postData) =>
    post(`practices/farms/${farmId}`, postData);

export const deleteProfessionPractice = (farmId, professionId) =>
    del(`practices/farms/${farmId}/professions/${professionId}`);

export const postProfessionFarm = (farmId, professionId) =>
    post(`practices/farms/${farmId}/professions/${professionId}`);

export const getProfessionPractices = farmId => get(`practices/farms/${farmId}`);
